var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { expand } from "jsonld";
import { fetch } from "cross-fetch";
export const ContextUrl = {
    v2_vc: "https://www.w3.org/ns/credentials/v2",
    v4_alpha: "https://schemata.openattestation.com/com/openattestation/4.0/alpha-context.json",
};
export const ContextType = {
    BaseContext: "VerifiableCredential",
    V4AlphaContext: "OpenAttestationCredential",
};
const preloadedContextList = [ContextUrl.v2_vc, ContextUrl.v4_alpha];
const contexts = new Map();
// Preload frequently used contexts
// https://github.com/digitalbazaar/jsonld.js?tab=readme-ov-file#custom-document-loader
let isFirstLoad = true;
// FIXME: @types/json-ld seems to be outdated as callback is supposed to be options
const documentLoader = (url, _) => __awaiter(void 0, void 0, void 0, function* () {
    if (isFirstLoad) {
        isFirstLoad = false;
        for (const url of preloadedContextList) {
            const document = yield fetch(url).then((res) => res.json());
            contexts.set(url, document);
        }
    }
    if (contexts.get(url)) {
        return {
            contextUrl: undefined,
            document: contexts.get(url),
            documentUrl: url, // this is the actual context URL after redirects
        };
    }
    else {
        const document = yield fetch(url).then((res) => res.json());
        return { contextUrl: undefined, document, documentUrl: url };
    }
});
export const interpretContexts = (input) => __awaiter(void 0, void 0, void 0, function* () {
    const expanded = yield expand(input, { documentLoader }).catch((e) => {
        throw new UnableToInterpretContextError(JSON.stringify(e, null, 2));
    });
    const type = expanded[0]["@type"] || [];
    const unknownTypes = type.filter((t) => t.startsWith("https://www.w3.org/ns/credentials/issuer-dependent#")); // Workaround as expansionMap no longer supported
    if (unknownTypes.length > 0) {
        throw new UnableToInterpretContextError(`Unknown types found: ${unknownTypes.map((t) => t.split("#")[1])}`);
    }
});
export class UnableToInterpretContextError extends Error {
    constructor(details) {
        super(`Unable to interpret @context:\n${details}`);
        Object.setPrototypeOf(this, UnableToInterpretContextError.prototype);
    }
}
